import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const ViewTopBannerDetails = Loader(
  lazy(
    () =>
      import('src/content/admin-content/BannerManagement/ViewBanner/TopBanner')
  )
);

const ViewBottomBannerDetails = Loader(
  lazy(
    () =>
      import(
        'src/content/admin-content/BannerManagement/ViewBanner/BottomBanner'
      )
  )
);

const AddTopBanner = Loader(
  lazy(() => import('src/content/admin-content/BannerManagement/AddTopBanner'))
);

const AddBottomBanner = Loader(
  lazy(
    () => import('src/content/admin-content/BannerManagement/AddBottomBanner')
  )
);
const InactiveBottomBanner = Loader(
  lazy(
    () =>
      import(
        'src/content/admin-content/BannerManagement/InactiveBottomBanner/BottomInactiveBanner'
      )
  )
);
const InactiveTopBanner = Loader(
  lazy(
    () =>
      import(
        'src/content/admin-content/BannerManagement/InactiveTopBanner/TopInactiveBanner'
      )
  )
);

const ClicksDetail = Loader(
  lazy(
    () =>
      import('src/content/admin-content/BannerManagement/ClicksDetail/index')
  )
);

const BannerDataRoutesAdmin = [
  {
    path: '',
    element: <Navigate to="banner-data" replace />
  },
  {
    path: 'banner-data',
    children: [
      {
        path: 'banner-top',
        element: <ViewTopBannerDetails />
      },
      {
        path: 'banner-bottom',
        element: <ViewBottomBannerDetails />
      },
      {
        path: 'add-or-update-banner-top',
        element: <AddTopBanner />
      },
      {
        path: 'add-or-update-banner-bottom',
        element: <AddBottomBanner />
      },
      {
        path: 'inactive-bottom-banner',
        element: <InactiveBottomBanner />
      },
      {
        path: 'inactive-top-banner',
        element: <InactiveTopBanner />
      },
      {
        path: 'clicks-detail',
        element: <ClicksDetail />
      }
    ]
  }
];

export default BannerDataRoutesAdmin;
